module.exports = __webpack_public_path__ + "static/media/AZ.a847cefc.svg";